$(document).ready(function () {

  // Creates fade effect to remove the 'P' animation on page load. Function will trigger 4 seconds after the page loads.
  window.setTimeout(function () {
    $('.introVideoWrap').css('opacity', 0)
  }, 4000)

  // After fading, remove the element from the DOM, making everything clickable.
  window.setTimeout(function () {
    $('.introVideoWrap').css('display', 'none')
  }, 4500)

  // Triggers the wave effect on the first paragraph.
  window.setTimeout(function (i) {
    for (i = 0; i < $('.strip span').length; i++) {
      (function (ind) {
        setTimeout(function () {
          $('#status > .strip span:not(".row")').eq(ind).toggleClass('animate')
        }, ind * 15)
      })(i)
    }
  }, 4500)

  // $('.trigger-strip').on('click', function () {
  //   $('#status > .strip span:not(".row")').each((i, e) => {
  //     setTimeout(function () {
  //       $(e).addClass('animate')
  //     }, i * 15)
  //   })
  // })

  window.setTimeout(function () {
    $('.intro__statement--first').addClass('text-holder').addClass('active')
  }, 4600)
})



// WEBPACK FOOTER //
// ./src/assets/js/_logoAnimation.js